import { Button, Chip } from '@mui/material';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { convertToMexicoTime } from 'utils/helpers/convertToMexicoTime';
//import ActionsMenu from "utils/ActionsMenuDatagrid";
import ActionLabels from 'utils/ActionLabelsDatagrid';
import CurrencyFormatter from 'utils/helpers/CurrencyFormatter';

export const useTransactionsStripeHook = ({
  stripeAction,
  listStripe,
  cleanStripeAction,
  detailStripeAction,
  cleanDetailStripeAction,
  detailTransactionsStripe,
  actionReportTransactionsFraud,
  cleanReportTransactionsFraud,
  cleanReportPrepaidChargebackDetails,
  reportTransactionsFraud,
  actionReportTransactionsChargeback,
  reportTransactionsChargeback,
  transactionId,
  onClose,
}) => {
  const { payload } = listStripe || {};
  const { response } = detailTransactionsStripe || {};
  const { rows, pagination } = payload || {};

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useState({});
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(50);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState('');
  const [dialogTitleMessage, setDialogTitleMessage] = useState(false);
  const [isDialogOpenDetails, setIsDialogOpenDetails] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [action, setAction] = useState(null);
  const [openActionFraud, setOpenActionFraud] = useState(false);
  const [descriptionTransaction, setDescriptionTransaction] = useState('');
  const [loadingFraudAndChargeback, setLoadingFraudAndChargeback] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);

  const [error, setError] = useState(false);
  const [isError, setIsError] = useState(false);
  const [StripeTransactionId, setStripeTransactionId] = useState('');
  const [mappedRows, setMappedRows] = useState([]);

  useEffect(() => {
    if (transactionId) {
      // setLoading(true);
      setIsDialogOpenDetails(true);
      detailStripeAction(transactionId);
    }
  }, [transactionId, detailStripeAction, setIsDialogOpenDetails]);

  useEffect(() => {
    if (response?.response?.status > 200) {
      setIsDialogOpenDetails(true);
      setDialogMessage('Error');
      setDialogMessage(response?.response?.data?.detail);
      setIsDialogOpen(true);
      setLoading(false);
    }
  }, [response]);

  // Solo buscar cuando searchParams cambie Y la búsqueda fue disparada por el usuario o por URL
  const [shouldSearch, setShouldSearch] = useState(false);
  useEffect(() => {
    if (shouldSearch) {
      setLoading(true);
      const paramsToSend = Object.keys(searchParams).length !== 0 ? searchParams : undefined;
      stripeAction(page, size, paramsToSend)
        .then(() => setLoading(false))
        .catch(() => {
          setLoading(false);
        });
    }
    return () => {
      cleanStripeAction();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, stripeAction, cleanStripeAction, shouldSearch]);

  useEffect(() => {
    // Si el usuario ya disparó búsqueda, permite paginación
    if (shouldSearch && Object.keys(searchParams).length !== 0) {
      setLoading(true);
      stripeAction(page, size, searchParams)
        .then(() => setLoading(false))
        .catch(() => {
          setLoading(false);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, size, shouldSearch]);

  useEffect(() => {
    if (listStripe?.status === 200) {
      setLoading(false);
    } else if (listStripe?.payload?.response?.status > 200) {
      setDialogTitleMessage(listStripe?.payload?.response?.data?.title);
      setDialogMessage(listStripe?.payload?.response?.data?.detail || 'Ocurrió un error.');
      setIsDialogOpen(true);
      setLoading(false);
    }
  }, [listStripe]);

  const onSubmit = (data) => {
    // Permite filtros opcionales: si no hay ninguno, llama sin params
    setMappedRows([]);
    setPage(1);
    const filteredData = Object.fromEntries(
      Object.entries(data).filter(([, value]) => value !== ''),
    );
    setSearchParams(filteredData);
    setErrorMessage('');
    setShouldSearch(true);
    // Actualiza la URL con los filtros
    const params = new URLSearchParams(filteredData).toString();
    window.history.replaceState(null, '', params ? `?${params}` : window.location.pathname);
  };
  // Al cargar, si hay params en la URL, setea los filtros y busca automáticamente
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const initialFilters = {};
    params.forEach((value, key) => {
      initialFilters[key] = value;
    });
    if (Object.keys(initialFilters).length > 0) {
      setSearchParams(initialFilters);
      setShouldSearch(true);
      // Setea los valores en el formulario
      Object.entries(initialFilters).forEach(([key, value]) => {
        setValue(key, value);
      });
    }
  }, [setValue]);

  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  const handleChangePageSize = (newSize) => {
    setSize(newSize);
    setPage(1);
  };

  useEffect(() => {
    if (rows) {
      const updatedRows = rows.map((row) => ({
        ...row,
        id: `${row.id}`,
      }));
      setMappedRows(updatedRows);
    }
  }, [rows]);

  const handleIdButtonClick = (id) => {
    setStripeTransactionId(id);
    if (id) {
      setIsDialogOpenDetails(true);
      detailStripeAction(id)
        .then(() => setLoading(false))
        .catch(() => {
          setDialogMessage('Error');
          setDialogMessage('Error al cargar los detalles de la transferencia.');
          setIsDialogOpen(true);
          setLoading(false);
        });

      return () => {
        cleanDetailStripeAction();
      };
    }
  };

  const handleClose = () => {
    setIsDialogOpen(false);
    setIsDialogOpenDetails(false);
    cleanDetailStripeAction();
    if (transactionId) {
      onClose();
    }
  };

  const getStatusColor = (paymentStatus) => {
    switch (paymentStatus) {
      case 'succeeded':
        return 'green';
      case 'failed':
        return 'red';
      case 'Review':
        return 'Orange';
      default:
        return 'purple';
    }
  };

  const translationMap = {
    Requested: 'Transacción registrada',
    succeeded: 'Transacción exitosa',
    failed: 'Falló al procesar el pago',
    Review: 'En espera de revisión',
    Error: 'Error al procesar el pago',
  };

  const handleFraudPrevention = () => {
    setLoadingFraudAndChargeback(true);
    const payload = {
      txn_payment_id: StripeTransactionId,
      descriptionTransaction,
      payment_provider_name: 'STRIPE',
    };
    actionReportTransactionsFraud({ ...payload });
  };

  const handleChargebackPrevention = () => {
    setLoadingFraudAndChargeback(true);
    const payload = {
      txn_payment_id: StripeTransactionId,
      descriptionTransaction,
      payment_provider_name: 'STRIPE',
    };
    actionReportTransactionsChargeback({ ...payload });
  };

  const handleCloseFraudChargeback = () => {
    setOpenActionFraud(false);
    setDescriptionTransaction('');
    setError(false);
    setDialogMessage('');

    if (action === 'fraud') {
      cleanReportTransactionsFraud();
    } else if (action === 'chargeback') {
      cleanReportPrepaidChargebackDetails();
    }

    setLoading(true);

    stripeAction(page, size, searchParams)
      .then(() => setLoading(false))

      .catch(() => {
        setLoading(false);
      });
  };

  const handleOpenPopUp = (action, rowId) => {
    setAction(action);
    setSelectedRowId(rowId);
    setOpenActionFraud(true);
  };

  const handleConfirm = () => {
    if (descriptionTransaction === '') {
      setError(true);
    } else {
      setError(false);
      if (action === 'fraud') {
        handleFraudPrevention();
      } else if (action === 'chargeback') {
        handleChargebackPrevention();
      }
    }
  };

  useEffect(() => {
    if (reportTransactionsChargeback?.status === 200) {
      setDialogMessage('La operación se completó con éxito.');
      setIsError(false);
      setLoadingFraudAndChargeback(false);
      detailStripeAction(StripeTransactionId);
    } else if (reportTransactionsChargeback?.payload?.response?.status > 200) {
      setLoadingFraudAndChargeback(false);
      setDialogMessage(
        reportTransactionsChargeback?.payload?.response?.data?.detail || 'Ha ocurrido un error.',
      );
      setIsError(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportTransactionsChargeback]);

  useEffect(() => {
    if (reportTransactionsFraud?.status === 200) {
      setDialogMessage('La operación se completó con éxito.');
      setIsError(false);
      setLoadingFraudAndChargeback(false);
      detailStripeAction(StripeTransactionId);
    } else if (reportTransactionsFraud?.payload?.response?.status > 200) {
      setLoadingFraudAndChargeback(false);
      setDialogMessage(
        reportTransactionsFraud?.payload?.response?.data?.detail || 'Ha ocurrido un error.',
      );
      setIsError(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportTransactionsFraud]);

  const Columns = [
    {
      field: 'id',
      headerName: 'ID',
      width: 180,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <Button variant='outlined' onClick={() => handleIdButtonClick(params.row.id)}>
          {'Ver detalle'}
        </Button>
      ),
    },

    {
      field: 'prevention',
      headerName: 'Prevención',
      width: 200,
      headerAlign: 'center',
      renderCell: (params) => (
        <ActionLabels isFraud={params.row.is_fraud} isChargeback={params.row.is_chargeback} />
      ),
    },
    {
      field: 'stripe_created_at',
      headerName: 'Fecha Stripe',
      width: 250,
      align: 'center',
      headerAlign: 'center',
      valueGetter: (params) => {
        return convertToMexicoTime(params);
      },
    },
    {
      field: 'installments',
      headerName: 'Mensualidades',
      width: 200,
      align: 'right',
      headerAlign: 'center',
      renderCell: (params) => {
        const value = params.value;
        return value === 1 ? 'Contado' : value ? `${value} meses` : 'N/A';
      },
    },
    {
      field: 'status',
      headerName: 'Estado de pago',
      width: 220,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <Chip
          label={translationMap[params.row.status] || params.row.status}
          style={{
            backgroundColor: getStatusColor(params.row.status),
            color: 'white',
          }}
        />
      ),
    },

    {
      field: 'authorization_code',
      headerName: 'Autorización',
      width: 200,
      align: 'right',
      headerAlign: 'center',
    },
    {
      field: 'masked_card',
      headerName: 'Tarjeta',
      width: 200,
      align: 'right',
      headerAlign: 'center',
    },
    {
      field: 'amount',
      headerName: 'Monto',
      width: 120,
      align: 'right',
      headerAlign: 'center',
      renderCell: (params) => <CurrencyFormatter amount={params.value} />,
    },
    {
      field: 'failure_message',
      headerName: 'Mensaje',
      width: 200,
      headerAlign: 'center',
    },
    // {
    //     field: "actions",
    //     headerName: "Acciones",
    //     width: 200,
    //     headerAlign: "center",
    //     renderCell: (params) => (
    //         <ActionsMenu
    //             onFraud={() => handleOpenPopUp("fraud", params.id)}
    //             onChargeback={() =>
    //                 handleOpenPopUp("chargeback", params.id)
    //             }
    //         />
    //     ),
    // },
  ];

  return {
    register,
    handleSubmit,
    errors,
    onSubmit,
    loading,
    page,
    size,
    handleChangePage,
    pagination: {
      ...pagination,
      handleChangePage,
      handleChangePageSize,
    },
    rows,
    mappedRows,
    Columns,
    isDialogOpen,
    setIsDialogOpen,
    dialogTitleMessage,
    dialogMessage,
    handleClose,
    isDialogOpenDetails,
    errorMessage,
    setErrorMessage,
    handleConfirm,
    handleCloseFraudChargeback,
    openActionFraud,
    setDescriptionTransaction,
    setError,
    loadingFraudAndChargeback,
    error,
    isError,
    handleOpenPopUp,
    setLoading,
    selectedRowId,
  };
};
